import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { useState } from 'react'

import a11yProps from '../../../helpers/tabs'
import {
  AirChartWithNoSSR,
  CombinedChartsWithNoSSR,
  DwellChartWithNoSSR,
  LoyaltiesChartWithNoSSR,
  VisitorsChartWithNoSSR,
  WeatherChartWithNoSSR,
} from '../../Charts/Tabs'
import { tabLabels } from './Data'
import TabPanel from './TabPanel'

const TabList = () => {
  const [value, setValue] = useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="Chart tabs">
          {tabLabels.map((label, i) => (
            <Tab key={i} label={label} {...a11yProps(i)} />
          ))}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <VisitorsChartWithNoSSR />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DwellChartWithNoSSR />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <LoyaltiesChartWithNoSSR />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <WeatherChartWithNoSSR />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <AirChartWithNoSSR />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <CombinedChartsWithNoSSR />
      </TabPanel>
    </Box>
  )
}

export default TabList
